import { render } from "./GiftShow.vue?vue&type=template&id=099b0180&scoped=true"
import script from "./GiftShow.vue?vue&type=script&lang=js"
export * from "./GiftShow.vue?vue&type=script&lang=js"

import "./GiftShow.vue?vue&type=style&index=0&id=099b0180&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099b0180"]])

export default __exports__